export var ImageSizeType;
(function (ImageSizeType) {
    ImageSizeType["SMALL"] = "SMALL";
    ImageSizeType["WIDE"] = "WIDE";
})(ImageSizeType || (ImageSizeType = {}));
export var BannerType;
(function (BannerType) {
    BannerType["ADD_TO_SLIP"] = "Add to Slip";
    BannerType["GAME"] = "Game";
    BannerType["PROMOTION"] = "Promotion";
    BannerType["REDIRECTION"] = "Redirection";
})(BannerType || (BannerType = {})); // TODO: Maybe uppercase?
export const BLANK = '_blank';
export const CLICK_THRESHOLD_AREA = 5;
export const ANALYTICS_TRACKING_TIMEOUT = 100;
export const NAVIGATION_BUTTONS_HEIGHT = '39px';
export const IMAGE_RESOLUTION_SMALL = {
    width: 599,
    height: 277,
};
export const IMAGE_RESOLUTION_WIDE = {
    width: 1280,
    height: 184,
};
// Message Bus topics
export const MB_ADD_TO_SLIP = 'wh.sports.betslip.adapter.leg.add';
export const MB_EVENT_PARTIAL = 'wh.common.command.dli.tl.eventPartial';
export const MB_TRACK_COMPLETED = 'wh.analytics.event.interaction.track.completed';
export const MB_ANALYTICS_ADAPTER_READY = 'wh.analytics.adapter.ready';
// Analytics tracking event values
export const TRACKING_EVENT_NAME = 'banner_click';
